// extracted by mini-css-extract-plugin
module.exports = {"body":"ModalBody_body__iVrB3"};